import isEmpty from './isEmpty';

const determineMediaType = ({ url }: { url: string }) => {
  if (isEmpty({ value: url })) return null;

  const lowerUrl = url?.toLowerCase();

  // Define arrays for image, SVG, and video extensions
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.webp'];
  const svgExtensions = ['.svg'];
  const videoExtensions = [
    '.mp4',
    '.avi',
    '.mov',
    '.wmv',
    '.flv',
    '.mkv',
    '.webm',
    '.mpeg',
    '.mpg',
  ];

  // Determine the content type based on the URL extension
  if (imageExtensions.some((ext) => lowerUrl?.endsWith(ext))) {
    return 'image';
  } else if (svgExtensions.some((ext) => lowerUrl?.endsWith(ext))) {
    return 'svg';
  } else if (videoExtensions.some((ext) => lowerUrl?.endsWith(ext))) {
    return 'video';
  } else {
    return 'unknown';
  }
};

export default determineMediaType;
